import { useEffect } from 'react';

type UsePageErrorResetProps = {
  error: unknown;
  pageNumber: number;
  firstPage: number;
  setPageNumber: (page: number) => void;
};

export default function usePageErrorReset({
  error,
  pageNumber,
  firstPage,
  setPageNumber,
}: UsePageErrorResetProps) {
  useEffect(() => {
    if (error && pageNumber > firstPage) setPageNumber(firstPage);
  }, [error, pageNumber, firstPage, setPageNumber]);
}
